import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useMutation } from '@tanstack/vue-query'

export const useLoadInventoryFiles = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.file(`/inventory/objects/passport/${data.id}/files`, data.files)
    },
  })

  const upload = async (data: any) => {
    try {
      const result = await mutation.mutateAsync(data)
      addSuccess(trs('itf.saved'))

      return result
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    upload,
  }
}
